/**
 * newspaperPermissionAssignment Module
 *
 * Description 报纸权限分配
 * Author:SMG 2016-6-7
 */
'use strict';
angular
    .module('newspaperPermissionAssignment', ['manageCfg.roleManageMent.permissionAssignment.SavePerModule'])
    .controller('newspaperPermissionAssignmentCtrl', [
        '$scope',
        '$timeout',
        '$state',
        '$modal',
        '$q',
        'localStorageService',
        'trsHttpService',
        'modalDialog',
        'permissionAssignmentService',
        function(
            $scope,
            $timeout,
            $state,
            $modal,
            $q,
            localStorageService,
            trsHttpService,
            modalDialog,
            permissionAssignmentService
        ) {
            // 声明将要保存权限的数组对象开始
            var selecetedChanls = {};
            // 声明将要保存权限的数组对象结束
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    isBM: false // 是否是版面
                };
                $scope.data = {};
            }
            $scope.productAndModule = function() {
                $modal.open({
                    templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/productAndModule/productAndModule_tpl.html',
                    scope: $scope,
                    windowClass: 'manage-authorityAssignment',
                    backdrop: false,
                    controller: 'productAndModuleCtrl',
                });
            };
            $scope.channelTreeOptions = {
                nodeChildren: 'CHILDREN',
                injectClasses: {
                    ul: 'a1',
                    li: 'manage-main-rightDiv-leftDiv-treeLi',
                    liSelected: 'a7',
                    iExpanded: 'a3', // "manage-main-rightDiv-leftDiv-treeIcon",
                    iCollapsed: 'a4', // "manage-main-rightDiv-leftDiv-treeIcon",
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'a8',
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN === 'false';
                },
                dirSelectable: true,
                allowDeselect: false,
            };

            /**
             * [isAuthorized description] 判断是否已赋权，渲染左侧树节点
             * @param   {[type]}  node  [node description]
             * @return  {[type]}        [return description]
             */
            $scope.isAuthorized = function(node) {
                var flag = false;
                if (angular.isDefined(node.RIGHTINDEX)) {
                    var rightIndexs = node.RIGHTINDEX.split(',');
                    for (var i = 0; i < rightIndexs.length; i++) {
                        if (node.RIGHTVALUE[parseInt(rightIndexs[i].replace(/\"/g, '')) - 1] === '1') {
                            flag = true;
                        }
                    }
                }
                return flag;
            };
            $scope.cTshowSelected = function(sel) {
                permissionAssignmentService.initGroupRight(sel, $scope.roleData.ROLEID).then(function(data) {
                    sel.RIGHTID = data; // data;
                    delete $scope.rightClassify;
                    $scope.authorSelectedNode = sel;
                    if (!sel.OBJTYPE) { // 选中版面节点，
                        return;
                    }
                    if (sel.CHNLTYPE && sel.CHNLTYPE === '21') { // 选中叠次时
                        return;
                    }
                    if (!angular.isArray($scope.authorSelectedNode.RIGHTVALUE)) {
                        $scope.authorSelectedNode.RIGHTVALUE = $scope.authorSelectedNode.RIGHTVALUE.split('');
                        $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                    }
                    if (sel.CHNLTYPE && sel.CHNLTYPE !== '21') {
                        if ($scope.data.selectedBMDiecitype !== $scope.authorSelectedNode.DIECITYPE) {
                            $scope.data.selectedBMDiecitype = $scope.authorSelectedNode.DIECITYPE;
                            $scope.batSetChanls = {};
                        }
                        $scope.status.isBM = true;
                        // 将要推送的保存权限对象开始
                        var tempId = $scope.authorSelectedNode.OBJID;
                        var tempObj = {
                            ID: parseInt($scope.authorSelectedNode.RIGHTID),
                            OPRTYPE: 203,
                            OPRID: parseInt($scope.roleData.ROLEID),
                            OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                            OBJID: parseInt($scope.authorSelectedNode.OBJID),
                            NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                        };
    
                        selecetedChanls[tempId] = tempObj;
                    } else {
                        $scope.status.isBM = false;
                    }
                    // 将要推送的保存权限对象结束
                    queryRightClassify($scope.classify, sel);
                    $scope.isPaper = true;
                    var paperRightParams = {
                        serviceid: 'mlf_paperset',
                        methodname: 'queryPaperRightClassify',
                        SiteId: $scope.siteId,
                        RoleId: $scope.roleData.ROLEID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paperRightParams, 'post').then(function(data) {
                        $scope.pageIds = data.BMIDS === '' ? [] : data.BMIDS.split(',');
                    });
                });
            };
            // 处理节点名称，用于应对不同模块类型节点名称显示
            $scope.getNodeDesc = function(node) {
                return angular.isDefined(node.MODALDESC) ? node.MODALDESC : angular.isDefined(node.SITEDESC) ? node.SITEDESC : node.CHNLDESC;
            };
            $scope.SavePermissions = function() {
                $modal.open({
                    templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/SavePerModule/SavePerModule.html',
                    scope: $scope,
                    windowClass: 'manageSavePerTemp',
                    backdrop: false,
                    controller: 'SavePerModuleController',
                });
            };
            // 保存权限开始
            $scope.save = function() {
                let rightsArray = angular.copy($scope.authorSelectedNode.RIGHTVALUE);
                var i = 0,
                    postRights = [];
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'saveRight',
                    RoleId: $scope.roleData.ROLEID,
                };
                if ($scope.status.isBM) {
                    concatPermission();
                    for (var key in selecetedChanls) {
                        postRights.push(angular.copy(selecetedChanls[key]));
                        postRights[i].NEWVALUE = angular.isArray(postRights[i].NEWVALUE) ? postRights[i].NEWVALUE.join('') : postRights[i].NEWVALUE;
                        i++;
                    }
                } else {
                    params.DieciType = $scope.perSelectedNode.DIECITYPE;
                    postRights = [
                        {
                            ID: parseInt($scope.perSelectedNode.RIGHTID),
                            OPRTYPE: 203,
                            OPRID: parseInt($scope.roleData.ROLEID),
                            OBJTYPE: parseInt($scope.perSelectedNode.OBJTYPE),
                            OBJID: parseInt($scope.perSelectedNode.OBJID),
                            NEWVALUE: angular.isArray(rightsArray)
                                ? rightsArray.join('')
                                : $scope.perSelectedNode.RIGHTVALUE,
                        },
                    ];
                }
                if (postRights.length === 0) {
                    modalDialog.alertType('您尚未设置权限', '您尚未设置权限', 'error', false);
                    return;
                }
                params.rights = JSON.stringify(postRights);
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post').then(function(data) {
                    getChannelTree($scope.siteId, $scope.roleData.ROLEID, function(data) {
                        $scope.channelTree = data;
                        treeLocation(true);
                    });
                    var setBelongBanMianParams = {
                        // 分配版面参数开始
                        serviceid: 'mlf_paperset',
                        methodname: 'setBelongBanMian',
                        RoleId: $scope.roleData.ROLEID,
                        SiteId: $scope.siteId,
                        ChannelIds: $scope.pageIds.join(','),
                    };
                    if (false && $scope.pageIds.length === 0 && $scope.isAuthorized($scope.perSelectedNode)) {
                        // 暂不执行
                    } else {
                        $scope.loadingPromise = trsHttpService
                            .httpServer(trsHttpService.getWCMRootUrl(), setBelongBanMianParams, 'post')
                            .then(function() {
                                modalDialog.alertType('保存权限成功', '', 'success', false);
                            });
                    }
                    return;
                });
            };
            // 保存权限结束
            /**
             * [getChannelTree description] 获取栏目树
             * @param   {[type]}  siteId    [siteId description]
             * @param   {[type]}  roleId    [roleId description]
             * @param   {[type]}  callback  [callback description]
             * @return  {[type]}            [return description]
             */
            function getChannelTree(siteId, roleId, callback) {
                var params = {
                    serviceid: 'mlf_website',
                    methodname: 'queryChannelTree',
                    SiteId: siteId,
                    RoleId: roleId,
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                    if (angular.isFunction(callback)) {
                        callback(data);
                    } else {
                        $scope.channelTree = data;
                    }
                });
            }

            /**
             * [getPaperChannelTree description] 获取报纸的树开始
             * @param   {[type]}  siteId  [siteId description]
             * @param   {[type]}  roleId  [roleId description]
             * @return  {[type]}          [return description]
             */
            function getPaperChannelTree(siteId, roleId) {
                var deffer = $q.defer();
                getChannelTree(siteId, roleId, function(data) {
                    // 如果是报纸的话，需要拆解点击产品得到的树
                    $scope.channelTree = angular.copy(data);
                    // delete $scope.channelTree[0].CHILDREN;
                    // $scope.channelTree[0].HASCHILDREN = 'false';
                    treeLocation().then(function() {
                        // 构造采编版面列表
                        var params = {
                            serviceid: 'mlf_mediasite',
                            methodname: 'getPaperChannelTree',
                            PaperId: $scope.siteId,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            $scope.pages = data;
                            deffer.resolve(data);
                        });
                    });
                });
                return deffer.promise;
            }
            // 获取报纸的树结束

            /**
             * [treeLocation description] 树节点自动定位
             * @param   {[type]}  flag  [flag description]
             * @return  {[type]}        [return description]
             */
            function treeLocation(flag) {
                var deffer = $q.defer();
                $scope.expandedNodes = [];
                expendsAllNode($scope.channelTree, flag);
                deffer.resolve();
                return deffer.promise;
            }

            /**
             * [expendsAllNode description] 默认展开所有的树节点
             * @param   {[type]}  node  [node description]
             * @param   {[type]}  flag  [flag description]
             * @return  {[type]}        [return description]
             */
            function expendsAllNode(node, flag) {
                for (var i = 0; i < node.length; i++) {
                    if (flag && node[i].OBJID === $scope.perSelectedNode.OBJID && node[i].DIECITYPE === $scope.data.selectedBMDiecitype) {
                        $scope.perSelectedNode = node[i];
                    }
                    $scope.expandedNodes.push(node[i]);
                    if (node[i].HASCHILDREN === 'true') {
                        expendsAllNode(node[i].CHILDREN, flag);
                    }
                }
            }

            /**
             * '[queryRightClassify description] 获取权限列表开始
             * @param   {[type]}  classify  [classify description]
             * @param   {[type]}  node      [node description]
             * @return  {[type]}            [return description]
             */
            function queryRightClassify(classify, node) {
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'queryRightClassify',
                    Classify: classify,
                    SiteId: $scope.siteId,
                    DieciType: node.DIECITYPE
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                    if ($scope.authorSelectedNode !== undefined) {
                        $scope.rightClassify = data;
                        // 初始化全选按钮开始
                        $scope.initSelectAll();
                        // 初始化全选按钮结束
                    }
                });
            }
            // 获取权限列表结束
            // 初始化全选按钮方法开始
            $scope.initSelectAll = function() {
                if (!$scope.rightClassify) { // 采编版面和照排版面是虚拟节点，没有赋权操作
                    return;
                }
                $scope.rightClassify.selectAll = true;
                for (var i = 0; i < $scope.rightClassify.CHILDREN.length; i++) {
                    $scope.rightClassify.CHILDREN[i].selectAll = true;
                    for (var j = 0; j < $scope.rightClassify.CHILDREN[i].CHILDREN.length; j++) {
                        if (
                            $scope.authorSelectedNode.RIGHTVALUE.length === 0 ||
                            $scope.authorSelectedNode.RIGHTVALUE[$scope.rightClassify.CHILDREN[i].CHILDREN[j].RIGHTINDEX - 1] == '0'
                        ) {
                            $scope.rightClassify.CHILDREN[i].selectAll = false;
                        }
                    }
                    if ($scope.rightClassify.CHILDREN[i].selectAll === false) {
                        $scope.rightClassify.selectAll = false;
                    }
                }
            };
            // 初始化全选按钮方法结束

            /**
             * [selectTemplateFn description] 选择模板
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            $scope.selectTemplateFn = function(index) {
                $timeout(function() {
                    if (!angular.isArray($scope.selectTemplate.NEWVALUE) && $scope.selectTemplate.NEWVALUE !== undefined) {
                        $scope.authorSelectedNode.RIGHTVALUE = $scope.selectTemplate.NEWVALUE.split('');
                        $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                        var tempObj = {
                            ID: parseInt($scope.authorSelectedNode.RIGHTID),
                            OPRTYPE: 203,
                            OPRID: parseInt($scope.roleData.ROLEID),
                            OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                            OBJID: parseInt($scope.authorSelectedNode.OBJID),
                            NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                        };
                        selecetedChanls[$scope.authorSelectedNode.OBJID] = tempObj;
                        // 全选按钮初始化开始
                        $scope.initSelectAll();
                        // 全选按钮初始化结束
                    }
                });
            };

            /**
             * [initData description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initData() {
                // 获取从产品列表得到的产品数据开始
                getProductListData();
                // 获取从产品列表得到的产品数据结束
                if ($scope.roleData === undefined) {
                    modalDialog.alertType('请先选择角色', '', 'info', false);
                    $state.go('manageconfig.rolemanage');
                }
                // 监控左边选择角色是否变动
                $scope.$on('roleData', function(event, roleData) {
                    $scope.roleData = roleData;
                    selecetedChanls = {};
                    $scope.batSetChanls = {};
                    getPaperChannelTree($scope.siteId, $scope.roleData.ROLEID).then(function() {
                        $scope.cTshowSelected($scope.channelTree[0]);
                        $scope.perSelectedNode = $scope.channelTree[0];
                    });
                    $scope.isPaper = true; // 加载报纸原子权限模板标识
                    delete $scope.rightClassify;
                });
                // 批量设置权限对象初始化开始
                $scope.batSetChanls = {};
                // 批量设置权限对象初始化结束
                $scope.batSetObj = {};
            }

            /**
             * [getProductListData description] 获取从产品列表得到产品数据开始
             * @return  {[type]}  [return description]
             */
            function getProductListData() {
                var productListData = localStorageService.get('setEditingCenterPermission');
                $scope.siteDesc = productListData.siteDesc;
                $scope.moduleName = productListData.moduleName;
                $scope.mediaType = productListData.mediaType;
                $scope.siteId = productListData.siteId;
                $scope.classify = productListData.CLASSIFY;
                delete $scope.rightClassify;
                selecetedChanls = {};
                getPaperChannelTree($scope.siteId, $scope.roleData.ROLEID).then(function() {
                    $scope.perSelectedNode = $scope.channelTree[0];
                    $scope.cTshowSelected($scope.channelTree[0]);
                });
            }
            // 获取从产品列表得到产品数据结束

            // 批量授权开始
            $scope.batPermissionAssignment = function(node) {
                // angular.isUndefined($scope.perSelectedNode.CHANNELID)
                if (!$scope.authorSelectedNode.CHNLTYPE || $scope.authorSelectedNode.CHNLTYPE === '21') {
                    modalDialog.alertType('版面不允许批量授权', '', 'warning', false);
                    return;
                }
                if (angular.isUndefined($scope.rightClassify)) {
                    modalDialog.alertType('请先选择要授权的节点', '', 'warning', false);
                    return;
                }
                if (angular.isDefined($scope.batSetChanls[node.OBJID])) {
                    delete $scope.batSetChanls[node.OBJID];
                    return;
                }
                $scope.batSetChanls[$scope.authorSelectedNode.OBJID] = {
                    ID: parseInt($scope.authorSelectedNode.RIGHTID),
                    OPRTYPE: 203,
                    OPRID: parseInt($scope.roleData.ROLEID),
                    OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                    OBJID: parseInt($scope.authorSelectedNode.OBJID),
                    NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                };
                permissionAssignmentService.initGroupRight(node, $scope.roleData.ROLEID).then(function(data) {
                    $scope.batSetObj = {
                        ID: parseInt(data),
                        OPRTYPE: 203,
                        OPRID: parseInt($scope.roleData.ROLEID),
                        OBJTYPE: parseInt(node.OBJTYPE),
                        OBJID: parseInt(node.OBJID),
                        NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                    };
                    updateBatPermissionAssignment();
                    $scope.batSetChanls[node.OBJID] = $scope.batSetObj;
                });
            };
            // 批量授权结束
            // 监控授权操作给批量对象赋值
            $scope.$watch('authorSelectedNode.RIGHTVALUE', function(newValue, oldValue) {
                updateBatPermissionAssignment();
            });
            // 监控授权操作给批量对象赋值
            /**
             * [updateBatPermissionAssignment description] 更新批量授权
             * @return  {[type]}  [return description]
             */
            function updateBatPermissionAssignment() {
                for (var i in $scope.batSetChanls) {
                    $scope.batSetChanls[i].NEWVALUE = angular.copy($scope.authorSelectedNode.RIGHTVALUE);
                }
            }

            /**
             * [concatPermission description] 合并批量授权和普通授权开始
             * @return  {[type]}  [return description]
             */
            function concatPermission() {
                for (var i in $scope.batSetChanls) {
                    selecetedChanls[i] = $scope.batSetChanls[i];
                }
            }
            // 合并批量授权和普通授权结束
            // 批量授权单选框是否选中判断方法
            $scope.batPerAssCheckboxSelected = function(node) {
                return !!angular.isDefined($scope.batSetChanls[node.OBJID]);
            };
        },
    ]);
